module.exports = {
  roomOnlyPriceText: 'Prezzo camera',
  includingOneWeekParkingText: 'incl. 1 settimana di parcheggio',
  carParkText: 'Parcheggio',
  hotelText: 'Hotel',
  starsText: 'Stelle',
  distanceText: 'Distanza',
  transfersText: 'Trasferimenti',
  loungeText: 'Lounge',
  timesText: 'Tempi',
  ratingText: 'Valutazione',
  priceText: 'Prezzo',
  pricePerDayText: 'Prezzo al giorno',
  pricePerWeekText: 'Prezzo a settimana',
  notRequiredText: 'Non necessario',
  minutesShortText: 'minuti',
  includedText: 'Incluso',
  milesText: 'miglia',
  onAirportText: 'all\'aeroporto',
  mapAndDirectionsText: 'Mappa e indicazioni',
  photosText: 'Foto',
  videoText: 'Video',
  reviewsText: 'Recensioni',
  customerReviewsText: 'Recensioni dei clienti',
  thisIsAGuidePriceOnlyText: 'Questo è solo un prezzo orientativo',
  loungeOpenTimesText: 'Questa lounge é aperta dalle ore OPENINGTIME alle ore CLOSINGTIME',
  loungeOpenTimesShortText: 'Aperta dalle ore <strong>OPENINGTIME</strong> alle ore <strong>CLOSINGTIME</strong>',
  bookAgainText: 'AVERAGEASPERCENTAGE% of COUNT clienti che prenoterebbero di nuovo questo parcheggio',
  carParkingCaveat: '*Questo è un esempio di prezzo per prenotazioni tra il giorno STARTDATE e  il giorno ENDDATE, valido come DATEUSED. Per prezzo a settimana  si intende il costo del parcheggio per 8 giorni. Il prezzo al giorno si riferisce allo stesso prodotto e periodo, diviso per 8.',
  otherCaveat: '*Questo è un esempio di prezzo per una prenotazione per il giorno STARTDATE, valida a partire da DATEUSED.',
  lowestPriceOnlyLabel: 'Da '
}



// WEBPACK FOOTER //
// ./shared/config/components/productList/it/index.js